import { render, staticRenderFns } from "./CheckBoxElement.vue?vue&type=template&id=88dab60a&"
import script from "./CheckBoxElement.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports